import { Accessibility } from './Accessibility/Accessibility'
import { Category } from './Category/Category'
import { DateHour } from './DateHour/DateHour'
import { OfferDuo } from './OfferDuo/OfferDuo'
import { Price } from './Price/Price'
import { Venue } from './Venue/Venue'

export default {
  Category,
  DateHour,
  OfferDuo,
  Price,
  Venue,
  Accessibility,
}
